import * as React from 'react';

import { head } from 'lodash';

interface IDigestProps {
  uuid: string;
}

export const Digest = ({ uuid }: IDigestProps) => <>#{head(uuid.split('-'))}</>;
